import React from 'react';

import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';

function DailySummaryTable({ title, rows, columns }) {
  return (
    <Paper variant="outlined" sx={{ overflow: 'hidden', width: 'fit-content', maxWidth: '100%' }}>
      <Typography variant="h6" sx={{ px: 2, py: 1.5 }}>
        {title}
      </Typography>
      <TableContainer sx={{ width: 'fit-content', maxWidth: '100%', overflowX: 'auto' }}>
        <Table size="small" aria-label={title} sx={{ width: 'max-content' }}>
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell key={column.key} align={column.align || 'left'}>
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.OrderDate} hover>
                {columns.map((column) => {
                  const rawValue = row?.[column.key];
                  const displayValue = column.render ? column.render(rawValue, row) : rawValue;

                  return (
                    <TableCell key={column.key} align={column.align || 'left'}>
                      {displayValue}
                    </TableCell>
                  );
                })}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}

export default React.memo(DailySummaryTable);
